import React from "react"
import { Link } from "gatsby"

const Bio = () => (
  <>
    <p>
      I'm Domenico (<strong>Dom</strong>) De Felice, Production Engineer at Meta.
    </p>
    <p>
      <strong>Lambda squared</strong> is my personal blog.
    </p>
    <p>
      I've been writing software since childhood, starting on a Commodore 64.
      These days I focus on infrastructure and distributed systems — building
      things that are fast, reliable, and run at scale. I've built orchestration
      systems, network automation, and tooling that supports ML training
      workloads. I care about systems that get out of the way so the interesting
      work can happen.
    </p>
    <p>
      <Link to="/contact/">Get in contact.</Link>
    </p>
  </>
)

export default Bio
